export class EntityTileState {
  isChecked: boolean[] = []
}
